export const GET_INCIDENTS = "GET_INCIDENTS";
export const GET_INCIDENTS_SUCCESS = "GET_INCIDENTS_SUCCESS";
export const GET_INCIDENTS_FAIL = "GET_INCIDENTS_FAIL";

export const CREATE_INCIDENT = "CREATE_INCIDENT";
export const CREATE_INCIDENT_SUCCESS = "CREATE_INCIDENT_SUCCESS";
export const CREATE_INCIDENT_FAIL = "CREATE_INCIDENT_FAIL";

export const GET_INCIDENT_BY_ID = "GET_INCIDENT_BY_ID";
export const GET_INCIDENT_BY_ID_SUCCESS = "GET_INCIDENT_BY_ID_SUCCESS";
export const GET_INCIDENT_BY_ID_FAIL = "GET_INCIDENT_BY_ID_FAIL";

export const UPDATE_INCIDENT = "UPDATE_INCIDENT";
export const UPDATE_INCIDENT_SUCCESS = "UPDATE_INCIDENT_SUCCESS";
export const UPDATE_INCIDENT_FAIL = "UPDATE_INCIDENT_FAIL";

export const CREATE_COMPONENT_SERVICE = "CREATE_COMPONENT_SERVICE";
export const CREATE_COMPONENT_SERVICE_SUCCESS = "CREATE_COMPONENT_SERVICE_SUCCESS";
export const CREATE_COMPONENT_SERVICE_FAIL = "CREATE_COMPONENT_SERVICE_FAIL";

export const GET_COMPONENT_SERVICES = "GET_COMPONENT_SERVICES";
export const GET_COMPONENT_SERVICES_SUCCESS = "GET_COMPONENT_SERVICES_SUCCESS";
export const GET_COMPONENT_SERVICES_FAIL = "GET_COMPONENT_SERVICES_FAIL";

export const GET_STATUS_PAGE_PUBLIC  = "GET_STATUS_PAGE_PUBLIC";
export const GET_STATUS_PAGE_PUBLIC_SUCCESS = "GET_STATUS_PAGE_PUBLIC_SUCCESS";
export const GET_STATUS_PAGE_PUBLIC_FAIL = "GET_STATUS_PAGE_PUBLIC_FAIL";

export const GET_TIMESTAMP_DATA = "GET_TIMESTAMP_DATA";
export const GET_TIMESTAMP_DATA_SUCCESS = "GET_TIMESTAMP_DATA_SUCCESS";
export const GET_TIMESTAMP_DATA_FAIL = "GET_TIMESTAMP_DATA_FAIL";

export const GET_TIMESTAMP_DATA_FOR_ONE_DAY = "GET_TIMESTAMP_DATA_FOR_ONE_DAY";
export const GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS = "GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS";
export const GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL = "GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL";

export const GET_UPTIME_DETAILS = "GET_UPTIME_DETAILS";
export const GET_UPTIME_DETAILS_SUCCESS = "GET_UPTIME_DETAILS_SUCCESS";
export const GET_UPTIME_DETAILS_FAIL = "GET_UPTIME_DETAILS_FAIL";

export const DELETE_COMPONENT_SERVICE = "DELETE_COMPONENT_SERVICE";
export const DELETE_COMPONENT_SERVICE_SUCCESS = "DELETE_COMPONENT_SERVICE_SUCCESS";
export const DELETE_COMPONENT_SERVICE_FAIL = "DELETE_COMPONENT_SERVICE_FAIL";

export const DELETE_INCIDENT = "DELETE_INCIDENT";
export const DELETE_INCIDENT_SUCCESS = "DELETE_INCIDENT_SUCCESS";
export const DELETE_INCIDENT_FAIL = "DELETE_INCIDENT_FAIL";

export const GET_COMPONENT_SERVICES_PUBLIC_PAGE = "GET_COMPONENT_SERVICES_PUBLIC_PAGE";
export const GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS = "GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS";
export const GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL = "GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL";

export const GET_INCIDENTS_PUBLIC_PAGE = "GET_INCIDENTS_PUBLIC_PAGE";
export const GET_INCIDENTS_PUBLIC_PAGE_SUCCESS = "GET_INCIDENTS_PUBLIC_PAGE_SUCCESS";
export const GET_INCIDENTS_PUBLIC_PAGE_FAIL = "GET_INCIDENTS_PUBLIC_PAGE_FAIL";

export const GET_TIMESTAMP_DATA_PUBLIC_PAGE = "GET_TIMESTAMP_DATA_PUBLIC_PAGE";
export const GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS = "GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS";
export const GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL = "GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL";

export const GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY = "GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY";
export const GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS = "GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS";
export const GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL = "GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL";

export const VERIFY_RECAPTCHA = "VERIFY_RECAPTCHA";
export const VERIFY_RECAPTCHA_SUCCESS = "VERIFY_RECAPTCHA_SUCCESS";
export const VERIFY_RECAPTCHA_FAIL = "VERIFY_RECAPTCHA_FAIL";

export const SUBSCRIBE_TO_STATUS_PAGE = "SUBSCRIBE_TO_STATUS_PAGE";
export const SUBSCRIBE_TO_STATUS_PAGE_SUCCESS = "SUBSCRIBE_TO_STATUS_PAGE_SUCCESS";
export const SUBSCRIBE_TO_STATUS_PAGE_FAIL = "SUBSCRIBE_TO_STATUS_PAGE_FAIL";

export const STATUS_PAGE_EMAIL_CONFIRMATION = "STATUS_PAGE_EMAIL_CONFIRMATION";
export const STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS = "STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS";
export const STATUS_PAGE_EMAIL_CONFIRMATION_FAIL = "STATUS_PAGE_EMAIL_CONFIRMATION_FAIL";

export const GET_EXTERNAL_COMPONENT_SERVICES = "GET_EXTERNAL_COMPONENT_SERVICES";
export const GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS = "GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS";
export const GET_EXTERNAL_COMPONENT_SERVICES_FAIL = "GET_EXTERNAL_COMPONENT_SERVICES_FAIL";

export const GET_AWS_HEALTH_EVENTS = "GET_AWS_HEALTH_EVENTS";
export const GET_AWS_HEALTH_EVENT_SUCCESS = "GET_AWS_HEALTH_EVENT_SUCCESS";
export const GET_AWS_HEALTH_EVENT_FAIL = "GET_AWS_HEALTH_EVENT_FAIL";

export const MAP_ALERTS_TO_COMPONENT_SERVICE = "MAP_ALERTS_TO_COMPONENT_SERVICE";
export const MAP_ALERTS_TO_COMPONENT_SERVICE_SUCCESS = "MAP_ALERTS_TO_COMPONENT_SERVICE_SUCCESS";
export const MAP_ALERTS_TO_COMPONENT_SERVICE_FAIL = "MAP_ALERTS_TO_COMPONENT_SERVICE_FAIL";

export const GET_MAPPED_ALERTS = "GET_MAPPED_ALERTS";
export const GET_MAPPED_ALERTS_SUCCESS = "GET_MAPPED_ALERTS_SUCCESS";
export const GET_MAPPED_ALERTS_FAIL = "GET_MAPPED_ALERTS_FAIL";

export const GET_ALL_RESOURCES = "GET_ALL_RESOURCES";
export const GET_ALL_RESOURCES_SUCCESS = "GET_ALL_RESOURCES_SUCCESS";
export const GET_ALL_RESOURCES_FAIL = "GET_ALL_RESOURCES_FAIL";

export const GET_RESOURCES_COUNT = "GET_RESOURCES_COUNT";
export const GET_RESOURCES_COUNT_SUCCESS = "GET_RESOURCES_COUNT_SUCCESS";
export const GET_RESOURCES_COUNT_FAIL = "GET_RESOURCES_COUNT_FAIL";

export const DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE = "DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE";
export const DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_SUCCESS = "DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_SUCCESS"
export const DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_FAIL = "DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_FAIL"
